import script from "./KanaNameModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./KanaNameModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__